<template>
  <slide-x-left-transition :duration="400+(index*100)" :delay="200+(index*100)">

    <ion-card v-if="show" class="item-downloads-file" mode="ios" style="margin: 0 0 20px 0px">
      <!--<a :href="file" download>-->
        <ion-item mode="ios" @click="handleClick($event)">
          <ion-thumbnail slot="start" style="width: 65px; height: 65px; padding: 15px 0">
            <img v-if="image" :src="image" style="width: 100%; height: auto">
            <ion-skeleton-text v-else animated></ion-skeleton-text>
          </ion-thumbnail>
          <ion-label mode="md" class="ion-text-wrap">
            <h3>{{ name }}</h3>
          </ion-label>
          <ion-thumbnail slot="end">
            <svg class="icon-inner" style="width: 20px; height: 55px; padding: 0 10px;">
              <use v-if="action === 'video'" xlink:href="#icon-video2"></use>
              <use v-else xlink:href="#icon-download"></use>
            </svg>
          </ion-thumbnail>
        </ion-item>
      <!--</a>-->
    </ion-card>

  </slide-x-left-transition>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
  name: 'ItemDownloadsFile',
  props: ['index', 'action', 'slug', 'file', 'image', 'name'],
  data() {
    return {
      show: false
    }
  },
  mounted() {
    this.show = true;
  },
  methods: {
    handleClick(e){
      (this.action === 'video') ? this.openModal() : window.open(this.file);
    },
    openModal() {
      return this.$ionic.modalController.create({
        component: Modal,
        mode: 'ios',
        componentProps: {
          propsData: {
            title: this.name,
            video: this.file
          },
        },
      }).then(m => m.present())
    },
  }
}
</script>

<style lang="scss">
.item-downloads-file {
  ion-card-content {
    padding: 0 20px 15px 15px;
  }

  ion-item {
    --inner-border-width: 0;
  }
}
</style>